import { Keyword } from "movieapi";
import * as React from "react";
import KeywordTable from "./KeywordTable";

export interface IChooseKeywordsProps {
  data: Keyword[] | undefined;
  handleKeywordChange: (keywords: Keyword[]) => void;
}

// tslint:disable-next-line:no-empty-interface
export interface IChooseKeywordsState {}

export default class ChooseKeywords extends React.Component<
  IChooseKeywordsProps,
  IChooseKeywordsState
> {
  constructor(props: IChooseKeywordsProps) {
    super(props);

    this.state = {};
  }

  public render() {
    return (
      <div>
        <p>Choose five keywords which describe your movie.</p>
        <KeywordTable
          data={this.props.data}
          handleKeywordChange={this.props.handleKeywordChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/ChooseKeywords.tsx